import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import "./Dashboard.scss";
import DigitalClock from "../../component/dashboard/digitalClock/DigitalClock";
import {ProfileService} from "../profile/ProfileService";

import {
    RaikoBaseCardContainer,
    RaikoDayGreeting,
    RaikoGridOneColumn, RaikoLabel, RaikoLabelType,
    RaikoSectionContainer,
    showServerErrorMessage,
    SidebarHolidaysList,
} from '@moeindal/base-raiko-panel-components';
import UserDashboardCard from "../../component/userDashboardCard/UserDashboardCard";
import {UsersListService} from "../../serverService/usersListService/UsersListService";
import RaikoBigBanner from "./bigBanner/RaikoBigBanner";
import DashboardVowReports from "./vowReport/DashboardVowReports";
import DashboardAppComments from "./comments/DashboardAppComments";
import DashboardHabitationReport from "./habitationReport/DashboardHabitationReport";
import RaikoSegmentSelect from "../../raikoComponents/raikoSegmentSelect/RaikoSegmentSelect";
import UserInstallationSummary from "./userInstallationSummary/UserInstallationSummary";
import {useAuthState} from "../../context/AuthContext";
import {AdminRoles} from "../../context/reducer";
import DashboardReportCard from "../../component/dashboardReportCard/DashboardReportCard";
import {PeriodService} from "../../serverService/periodService/PeriodService";
import {MawakibService} from "../../serverService/mawakibService/MawakibService";


const Dashboard = () => {


    const service = new ProfileService();
    const {role: roles = []} = useAuthState();


    const [adminFirstName, setAdminFirstName] = useState("");

    // console.log("today users is ", todayUsers)

    useEffect(() => {
        getAdminInfo();
    }, []);

    function getAdminInfo() {
        service.getProfileDetail()
            .then(response => {
                setAdminFirstName(response.firstName)
            }).catch(reason => {

        }).finally(_ => {

        })
    }

    const periodService = new PeriodService();
    const [periodLoading, setPeriodLoading] = useState(false);
    const [periodData, setPeriodData] = useState({
        "id": "",
        "title": "",
        "startDate": "",
        "endDate": ""
    })

    useEffect(() => {
        if (roles.includes(AdminRoles.READ_ACCOMMODATION_PERIODS_LIST.role)) {
            setPeriodLoading(true)
            periodService.getPeriodList(0, 1)
                .then(response => {
                    if (response.data.length > 0) {
                        const _item = response.data[0]
                        setPeriodData({
                            "id": _item.id,
                            "title": _item && _item.metaData && _item.metaData.title ? _item.metaData.title : "نامشخص",
                            "startDate": _item.startDate,
                            "endDate": _item.endDate
                        })
                    }

                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                setPeriodLoading(false)
            })
        }

    }, []);

    const mawakibService = new MawakibService()
    const [mawaLoading, setMawaLoading] = useState(false)
    const [mawakibData, setMawakibData] = useState({
        "id": "",
        "title": "",
        "startDate": "",
        "endDate": ""
    })

    useEffect(() => {
        if (roles.includes(AdminRoles.READ_MAWKIB_PERIODS_LIST.role)) {
            setMawaLoading(true)
            mawakibService.getMawakibList(0, 10)
                .then(response => {
                    if (response.data.length > 0) {
                        const _length = response.data.length
                        const _item = response.data[0]
                        setMawakibData({
                            "id": _item.id,
                            "title": _item && _item.title ? _item.title : "نامشخص",
                            "startDate": _item.startDate,
                            "endDate": _item.endDate
                        })
                    }

                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                setMawaLoading(false)
            })
        }

    }, []);


    return (
        <>
            <Helmet>
                <title>{RouteHelper.Dashboard.name}</title>
            </Helmet>
            <section className="dashboardLayout">
                <div className="dashboardContent">
                    {/*<RaikoDayGreeting
                        adminName={adminFirstName}
                        dayGreetingSubtitle={""}
                    />*/}
                    {roles.includes(AdminRoles.READ_USERS_LIST.role) ?
                        <UserInstallationSummary/> : ""
                    }
                    {
                        roles.includes(AdminRoles.READ_PAYMENT_TRANSACTIONS_LIST.role) ?
                            <DashboardVowReports/> : ""
                    }
                    {/*{*/}
                    {/*    roles.includes(AdminRoles.READ_ACCOMMODATION_PERIODS_LIST.role) ?*/}
                    {/*        <DashboardHabitationReport/> : ""*/}
                    {/*}*/}
                    {
                        roles.includes(AdminRoles.READ_ACCOMMODATION_PERIODS_LIST.role) ?
                            <DashboardReportCard
                                mainTitle={"آخرین دوره ی اسکان دهی"}
                                loading={periodLoading}
                                id={periodData.id}
                                title={periodData.title}
                                startDate={periodData.startDate}
                                endDate={periodData.endDate}
                                globalUrl={RouteHelper.PeriodDetails.globalUrl}
                            /> : ""
                    }
                    {
                        roles.includes(AdminRoles.READ_MAWKIB_PERIODS_LIST.role) ?
                            <DashboardReportCard
                                mainTitle={"آخرین دوره ی ثبت نام مواکب"}
                                loading={mawaLoading}
                                id={mawakibData.id}
                                title={mawakibData.title}
                                startDate={mawakibData.startDate}
                                endDate={mawakibData.endDate}
                                icon={"ic-ambulance"}
                                background={"backgroundColorPurple100"}
                                globalUrl={RouteHelper.MawakibDetails.globalUrl}
                            /> : ""
                    }
                    {/*<DashboardAppComments/>*/}
                </div>
                <div className="dashboardWrapper">
                    <RaikoBigBanner/>
                    <DigitalClock/>
                    <SidebarHolidaysList/>
                </div>

            </section>
        </>

    )
}

export default Dashboard;
const columns = [
    {
        id: 'id',
        label: '#'
    }, {
        id: 'firstName',
        label: 'نام'
    }, {
        id: 'lastName',
        label: 'نام خانوادگی'
    }, {
        id: 'age',
        label: 'سن',
    },
];